import React, { useEffect, useRef, useState } from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import PrimeReact from 'primereact/api';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';

import { useHistory } from 'react-router-dom';
import { useToast } from '../../../hooks/toast';
import { Container } from './styles';
import api from '../../../services/api';

 interface ICostDepositProperties {
  natureza_id: number | null;
  natureza_descricao: string;
}

const CostDeposit: React.FC = () => {
  // active ripple effect
  PrimeReact.ripple = true;

  const emptyCostDeposit = {
    natureza_id: null,
    natureza_descricao: '',
  };

  const [costDeposits, setCostDeposits] = useState<ICostDepositProperties[]>([]);
  const [costDeposit, setCostDeposit] = useState(emptyCostDeposit);
  const [deleteCostDeposit, setDeleteGroupDialog] = useState(false);
  const [deleteCostDepositsDialog, setDeleteGroupsDialog] = useState(false);
  const [selectedCostDeposits, setSelectedCostDeposits] = useState<ICostDepositProperties[]>([]);

  // para tabela
  const [globalFilter, setGlobalFilter] = useState('');
  const dt = useRef(null);
  const { addToast } = useToast();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      await api.get('/lawsuits/costsdeposits/show/all').then((response) => {
        setCostDeposits(response.data);
      });
    })();
  }, []);

  const columns = [
    { field: 'natureza_id', header: 'Código', sortable: true },
    { field: 'natureza_descricao', header: 'Descrição', sortable: true },
  ];

  const dynamicColumns = columns.map((col) => (
    <Column
      key={col.field}
      field={col.field}
      header={col.header}
      sortable
    />
  ));

  const handleCreate = () => {
    history.push('/lawsuit/costdeposit/create');
  };

  const hidedeleteCostDeposit = () => {
    setDeleteGroupDialog(false);
  };

  const hidedeleteCostDepositsDialog = () => {
    setDeleteGroupsDialog(false);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const editCostDeposit = (rowData:any) => {
    history.push(`/lawsuit/costdeposit/edit/${rowData.natureza_id}`);
  };

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const confirmDeleteCostDeposit = (costDeposit: React.SetStateAction<{
    natureza_id: null; natureza_descricao: string;
  }>) => {
    setCostDeposit(costDeposit);
    setDeleteGroupDialog(true);
  };

  const deleteGroup = () => {
    api.delete(`/lawsuits/costsdeposits/delete/${costDeposit.natureza_id}`);

    setDeleteGroupDialog(false);

    const updatedRecords = costDeposits
      .filter((val) => val.natureza_id !== costDeposit.natureza_id);
    setCostDeposits(updatedRecords);

    addToast({
      type: 'success',
      title: 'Cadastro excluído!',
      description:
        'O cadastro selecionado foi excluído com sucesso!',
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const actionBodyTemplate = (rowData: any) => (
    <>
      <Button
        type="button"
        icon="pi pi-pencil"
        tooltip="Alterar cadastro"
        tooltipOptions={{ position: 'left' }}
        className="p-button-rounded p-button-text p-button-plain p-mr-2"
        onClick={() => { editCostDeposit(rowData); }}
      />
      <Button
        type="button"
        icon="pi pi-trash"
        tooltip="Excluir cadastro"
        tooltipOptions={{ className: 'red-tooltip', position: 'left' }}
        className="p-button-rounded p-button-text p-button-plain"
        onClick={() => { confirmDeleteCostDeposit(rowData); }}
      />
    </>
  );

  const header = (
    <div className="flex align-items-center export-buttons">
      <Button
        type="button"
        label="Novo"
        icon="pi pi-plus"
        className="p-button-primary p-mr-2"
        onClick={handleCreate}
        tooltip="Novo cadastro"
        tooltipOptions={{ position: 'right' }}
      />
      <span className="p-input-icon-left p-ml-auto">
        <i className="pi pi-search" />
        <InputText type="search" value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar na tabela" />
      </span>
    </div>
  );

  const paginatorLeft = <Button type="button" icon="pi pi-refresh" className="p-button-text" />;
  const paginatorRight = <Button type="button" icon="pi pi-cloud" className="p-button-text" />;

  const deleteCostDepositFooter = (
    <>
      <Button type="button" label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteCostDeposit} />
      <Button type="button" label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteGroup} />
    </>
  );
  const deleteCostDepositsDialogFooter = (
    <>
      <Button type="button" label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteCostDepositsDialog} />
    </>
  );

  return (
    <Container>
      <header>
        <div>
          <h1>Natureza de Custas e Depósitos</h1>
        </div>
      </header>

      <div className="datatable-responsive">

        <div className="card">

          <Tooltip target=".export-buttons>button" position="bottom" />

          <DataTable
            tableClassName="table-costDeposits table"
            id="table-costDeposits"
            ref={dt}
            value={costDeposits}
            editMode="row"
            dataKey="natureza_id"
            header={header}
            stripedRows
            className="p-datatable-sm"
            paginator
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords}"
            rows={50}
            rowsPerPageOptions={[10, 20, 50]}
            paginatorLeft={paginatorLeft}
            paginatorRight={paginatorRight}
            globalFilter={globalFilter}
            emptyMessage="Nenhum registro encontrado."
            selectionMode="multiple"
            selection={selectedCostDeposits}
            onSelectionChange={(e) => {
              const selCostDeposits = e.value as ICostDepositProperties[];
              setSelectedCostDeposits(selCostDeposits);
            }}
            onRowDoubleClick={(e) => editCostDeposit(e.data)}
          >
            {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} /> */}
            {dynamicColumns}
            <Column body={actionBodyTemplate} align="right" style={{ width: '120px' }} />
          </DataTable>

        </div>

        <div>
          <Dialog visible={deleteCostDeposit} style={{ width: '450px' }} header="Confirmação" modal footer={deleteCostDepositFooter} onHide={hidedeleteCostDeposit}>
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {costDeposit && (
              <span>
                Você tem certeza que deseja excluir
                <br />
                <br />
                <b>{costDeposit.natureza_descricao}</b>
                ?
              </span>
              )}
            </div>
          </Dialog>

          <Dialog visible={deleteCostDepositsDialog} style={{ width: '450px' }} header="Confirmação" modal footer={deleteCostDepositsDialogFooter} onHide={hidedeleteCostDepositsDialog}>
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {costDeposit
              && <span>Você tem certeza que deseja excluir os cadastros selecionados?</span>}
            </div>
          </Dialog>
        </div>

      </div>

    </Container>

  );
};

export default CostDeposit;
